import styled from 'styled-components'
import { CTAButton, Text } from '../../../components/core'
import { Info } from '../../../components/icons'
import Theme from '../../../Theme'
import Carousel from './Carousel'
import { locations } from '../../../other/constants'
import useMobile from '../../../other/Hooks/useMobile'

const Overlay = styled.div<{ collapsed: boolean }>`
    position:absolute;
    top: ${({ collapsed }) => collapsed ? 'unset' : '0px'};
    right: ${({ collapsed }) => collapsed ? 'unset' : '0px'};
    left: ${({ collapsed }) => collapsed ? 74 : 0}px;
    bottom: ${({ collapsed }) => collapsed ? 25 : 0}px;
    z-index: 12;
    background-color: rgba(0, 0, 0, .25);
`

const Container = styled.div<{ collapsed: boolean }>` 
    position:absolute;
    background-color:${Theme.colors.White};
    box-shadow: 0px 0px 19px rgba(0, 0, 0, 0.25);
    z-index:2;
    bottom: ${({ collapsed }) => collapsed ? '0' : '25'}px;
    left: ${({ collapsed }) => collapsed ? '0' : '74'}px;
    width: ${({ collapsed }) => collapsed ? 28 : 38}vw;
    max-width: 550px;
    max-height: ${window.innerHeight - 50}px;;
    height: ${({ collapsed }) => collapsed ? '90px' : `${window.innerHeight - 50}px` };    
    padding: ${({ collapsed }) => collapsed ? 20 : 0}px;
    transition: width 1000ms ease-in-out, height 1000ms ease-in-out, padding 1000ms ease-in-out;
    ${({ collapsed }) => collapsed ? `
        > div {
            display: flex;
            alignItems: center;
            justify-content: space-between;
            @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
                display: flex;
                flex-direction: row;
            }   
        }
            ` : ''}

    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        top:60px;
        bottom:55px;
        left:50%;
        height:auto;
        width:90%;
        margin-left:-45%;
        }
    @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
        display:flex;
        flex-direction:row;
    }
    .expandedContainer {

        @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
            flex-direction: row !important;
        }
    }
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 15px;
    margin-left: 20px;
    padding-bottom:20px;
    padding-top:33px;
    overflow-y:hidden;
    @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
      padding:20px;
      width:60%;
      margin-right: auto;
      margin-left: auto;

    }
    
`
const HeaderContainer = styled.div`
    margin-top: 5px;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-content:center;
    cursor: pointer;
    width: 100%;
`
const Header = styled(Text) <{ collapsed?: boolean }>`
    display:inline-block;
    padding-bottom: ${({ collapsed }) => collapsed ? 0 : 10}px;
`

const Line = styled.div`
    border-bottom:2px solid #ED8B00;
    width: 0%;
    transition: all 500ms ease-in-out;
`
const Body = styled(Text)`
    margin-top:20px;
    padding-right: 40px;
    flex-grow: 1;
    overflow-y: auto;

    @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
        min-height:60%;
        max-height:80%;
      }
`


type PopupProps = {
    location: string
    closePopup: () => void
    view3D?: () => void
    openPopup?: () => void
    collapsed?: boolean
}

export default function Popup({ location, closePopup, view3D, collapsed, openPopup }: PopupProps) {
    const isMobile = useMobile()
    return (
        <Overlay collapsed={!!collapsed} onClick={closePopup}>
            <Container onClick={e => e.stopPropagation()} collapsed={!!collapsed} className='fadeIn'>
                {
                    collapsed
                        ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                            <HeaderContainer onClick={openPopup}>
                                <Header className='fadeInUp' collapsed={!!collapsed} variant={isMobile? "Header5" :"Header3"} color={Theme.colors.DarkGrey}>
                                    {location}
                                </Header>
                                <Info />
                            </HeaderContainer>
                            <Line className='growSmall' />
                        </div>
                        : <div className='expandedContainer' style={{ display: 'flex', flexDirection: 'column', maxHeight: '100%' }}>
                            <Carousel closePopup={closePopup} view3D={view3D} location={location} />
                            <TextContainer>
                                <div style={{ maxWidth: '80%' }}>
                                    <Header className='fadeInUp' variant="Header3" color={Theme.colors.DarkGrey}>
                                        {location}
                                    </Header>
                                    <Line className='growSmall' />
                                </div>

                                <Body className='fadeInUpDelay' variant="Body2" color={Theme.colors.Black}>
                                    {//@ts-ignore
                                        locations[location].size && <>
                                            {/* @ts-ignore */}
                                            <b>{locations[location].size}</b>
                                            <br />
                                            <br />
                                        </>
                                    }
                                    {//@ts-ignore
                                        locations[location].description
                                    }
                                    {/* {
                                        //@ts-ignore
                                        locations[location].bulletPoints && <ul style={{ listStyleType: 'circle', paddingTop: 15 }}>
                                            { //@ts-ignore
                                                locations[location].bulletPoints.map((b, i) => <li key={i}>{b}</li>)
                                            }
                                        </ul>
                                    } */}
                                    {
                                        //@ts-ignore
                                        locations[location].learnMore && <br />
                                    }
                                    {
                                        //@ts-ignore
                                        locations[location].learnMore &&
                                        <>
                                            <br />
                                            {/* @ts-ignore */}
                                            {locations[location].learnMore.label}
                                            <br />
                                            <CTAButton
                                                variant='solid'
                                                style={{ margin: '20px 0px 0px', width: isMobile ? '100%' : undefined }}
                                                onClick={() => {
                                                    //@ts-ignore
                                                    window.open(locations[location].learnMore.link, "_blank");
                                                }}>
                                                Learn More
                                            </CTAButton>
                                        </>
                                    }

                                </Body>
                            </TextContainer>
                        </div>
                }

            </Container>
        </Overlay>
    )
}

